import { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import HomePage from './pages/HomePage';
import SalesPage from './pages/SalesPage';
import RealEstatesPage from './pages/RealEstatesPage';
import NotFoundPage from './pages/NotFoundPage';
import { ScrollToTop } from './utilities/ScrollToTop';
import 'tailwindcss/tailwind.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import RealEstatesDetailPage from './pages/RealEstatesDetailPage';
import AnalyticsTracker from './components/AnalyticsTracker';
import { clearRealEstatesFilter } from './slices/realEstateSlice';

function SalesFiltersRouteGuard() {
  const location = useLocation();
  const dispatch = useDispatch();
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    const previousPath = previousPathRef.current;
    const currentPath = location.pathname;
    const wasOnSales = previousPath.startsWith('/ventas');
    const isOnSales = currentPath.startsWith('/ventas');

    if (wasOnSales && !isOnSales) {
      dispatch(clearRealEstatesFilter());
    }

    previousPathRef.current = currentPath;
  }, [dispatch, location.pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <BrowserRouter>
        <SalesFiltersRouteGuard />
        <AnalyticsTracker />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ventas" element={<SalesPage />} />
          <Route
            path="/ventas/detalle/:id"
            element={<RealEstatesDetailPage />}
          />
          <Route path="/inmuebles" element={<RealEstatesPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
